import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    fontSize: {
      type: String,
      default: "42"
    },
    color: {
      type: String,
      default: "#303650"
    },
    weight: {
      type: String,
      default: "700"
    },
    backColor: {
      type: String,
      default: "#F5F8FF"
    },
    isBj: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: "100,150,100,150"
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      titleAnimated: false,
      isVisible: false,
      observer: null
    };
  },
  computed: {
    titleAnimationClasses() {
      return {
        animate__animated: this.titleAnimated,
        animate__zoomIn: this.titleAnimated,
        "title-visible": this.titleAnimated // 添加可见状态
      };
    },
    paddingAll() {
      const tmp = this.padding.split(",");
      if (tmp.length == 1) {
        return tmp[0] + "px";
      } else if (tmp.length == 2) {
        return `${tmp[0]}px ${tmp[1]}px`;
      } else {
        return `${tmp[0]}px ${tmp[1]}px ${tmp[2]}px ${tmp[3]}px`;
      }
    }
  },
  mounted() {
    this.initObserver();
    if (this.isBj) {
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll(); // 初始化位置
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.isBj) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    initObserver() {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // isIntersecting判断目标元素当前是否可见
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.titleAnimated = true;
            this.$emit("startAnimation");
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px"
      });
      this.$nextTick(() => {
        if (this.$refs.monetizationSection) {
          this.observer.observe(this.$refs.monetizationSection);
        }
      });
    }
  }
};